import { useEffect, useState } from "react";
import { commonPostApi } from "../../utils/apiService";
import { convertToSearchField, generateColumnMetadata, orderObj } from "../../utils/utils";
import DataGrid from "../../components/common/dataGrid/dataGrid";
import DataGridHeader from "../../components/common/dataGrid/dataGridAddPatientHeader";
import moment from "moment";
import { useSelector } from "react-redux";
import { exportCSV, exportExcel, exportPdf } from "../../utils/exportUtils";
import { SORT_ORDER } from "../../constants/sortOrder";
import { LogisticsColumns } from "../../utils/serviceData";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";

export default function AllLogistic({
  api,
  dataKey,
  refresh,
  checkBox,
  handleClick,
  setCheckBox,
  optionsView,
  searchOption,
  secoundaryButton,
  isButtonEnabledLeft,
  selectable = false,
  currentPageHeader,
  searchField = ["patient_name", "phone_no", "patient_code", "visit_code","surgery_type","date_transportation"],
  columnArray = [],
  ...props
}) {
  const [values, setValues] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const id = useSelector((state) => state.common.camp?.camp_details_id);
  const initialVal = convertToSearchField(searchField, "");
  if (searchOption.trim()==="missed") {
  searchField.push("no_of_followup_calls");
  }
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "patient_name",
    sortDir: SORT_ORDER.ASC,
    searchCriteria: { ...initialVal,status: searchOption },
  });
  const init = async (navigator) => {
    let currentObj = {
      query: {
        page: navigator?.page,
        limit: navigator?.rows,
        searchCriteria: navigator?.searchCriteria,
        sortFields: navigator?.sortFields,
      },
    };
    let headers = {
      "Content-Type": "application/json",
    };
    let orderArray = [
      "visit_code",
      "patient_name",
      "patient_code",
      "phone_no",
      "status",
      "transportation_date",
    ];

    if (columnArray && columnArray?.length > 0) {
      orderArray = [...orderArray, ...columnArray];
    }
    await commonPostApi(api, currentObj, {
      headers,
    })
      .then((data = []) => {
        if (data?.data?.data) {
          const finalData = data?.data?.data;
          setNavigator((prev) => ({
            ...prev,
            totalRecords: data?.data?.total,
            page: data?.data?.currentPage,
          }));
          setColumns(
            orderObj(
              orderArray,
              generateColumnMetadata({
                data: finalData,
                alias: {
                  patient_code: "patient_id",
                  transportation_date: "trans_date",
                  no_of_followup_calls: "follow_up_calls",
                  phone_no: "phone number",
                  status: "surgery type",
                  visit_code: "patient_visit_code",
                  ...props?.alias,
                },
                defaultColumnsArr:LogisticsColumns,
              })?.filter((item) => orderArray?.includes(item?.name))
            )
          );
          setValues(finalData);
          setLoading(false);
        } else {
          setNavigator((prev) => ({
            ...prev,
            totalRecords: 1,
            page: 1,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchAllPatientsForExport = async () => {
    const exportObj = {
      query: {
        page: 1,
        limit: navigator.totalRecords, // fetch all records
        sortFields: [[navigator.sortBy, navigator.sortDir]],
        searchCriteria: navigator.searchCriteria,
      },
    };

    const res = await commonPostApi(API_ENDPOINTS.PATIENT_TRANSPORTATION_DETAILS, exportObj);
    const data = res?.data?.data || [];
    return data
  };

  function onPageChange(event) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      first: event?.first,
      page: event.page + 1,
    }));
    init({
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    });
  }

  const onRowCountChange = (e) => {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      page: 1,
      first: 0,
      rows: e?.target?.value,
    });
  };
  useEffect(() => {
    setNavigator((prev) => ({
      ...prev,
      searchCriteria: 
       navigator?.searchCriteria ,
      
    }));
    init({
      ...navigator,
      searchCriteria:  navigator?.searchCriteria,
    });
  }, [refresh, id]);

 const onSortClick = (event) => {
   setLoading(true);

   const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;

   const updatedNavigator = {
     ...navigator,
     sortBy: event?.sortField,
     sortDir: sortOrder,
     sortFields: [[event?.sortField, sortOrder]],
   };

   setNavigator(updatedNavigator);
   init(updatedNavigator);
 };

 function handleDateChange(date) {
   const formattedDate = date ? moment(date).format("YYYY-MM-DD") : "";

   const updatedNavigator = {
     ...navigator,
     searchCriteria: {
       ...navigator.searchCriteria,
       transportation_date: formattedDate,
     },
     page: 1,
   };

   setNavigator(updatedNavigator);
   init(updatedNavigator);
 }
  function handleSearchChange(value) {
     const data = convertToSearchField(searchField, value);
    setNavigator((prev) => ({
      ...prev,
      searchCriteria: {
        ...data,
        status:searchOption
        
      },
    }));
    init({
      ...navigator,
      searchCriteria: {
            ...data,
      status:searchOption
      },
    });
  }
  return (
    <div>
      <DataGrid
        header={
          <DataGridHeader
            secoundaryButton={secoundaryButton}
            handleClick={handleClick}
            checkBox={checkBox}
            isSearchEnabled={true}
            isDownloadButton={true}
            exportCSV={async () => {
              const allData = await fetchAllPatientsForExport();
              exportCSV(allData, columns, "Logistics");
            }}
            exportExcel={async () => {
              const allData = await fetchAllPatientsForExport();
              exportExcel(allData, columns, "Logistics");
            }}
            exportPdf={async() => {
              const allData = await fetchAllPatientsForExport();
              exportPdf(allData, columns, "Logistics");
            }}
            isCalenderEnabled={true}
            isButtonEnabledLeft={isButtonEnabledLeft}
            isButtonEnabledRight={false}
            currentPageHeader={currentPageHeader}
            onChange={handleSearchChange}
            handleDateChange={handleDateChange}
            searchPlaceHolder={"Search Patients"}
          />
        }
        selectable={selectable}
        onRowCountChange={onRowCountChange}
        onPageChange={onPageChange}
        onSortClick={onSortClick}
        navigator={navigator}
        column={columns}
        value={values}
        loading={loading}
        isAccordionEnabled={false}
        isPaginatorEnabled={true}
        selection={checkBox}
        dataKey={dataKey}
        sortable
        optionsView={optionsView}
        onSelectionChange={(e) => setCheckBox(e.value)}
      />
    </div>
  );
}
